import styled from "@emotion/styled";
import { colorPalette } from "../../../theme/colors";

export const ProductImage = styled.img`
  height: 80px;
  width: 60px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
  flex-shrink: 0;
  aspect-ratio: 3/4;
  border-top: 1px solid #f2f2f2;
  border-right: 1px solid #f2f2f2;
  border-left: 1px solid #f2f2f2;
`;
